import React from 'react'
import API from '../../services/api.jsx'
import Loader from '../layout/loader.jsx'
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import Table from '../layout/table.jsx'
import moment from 'moment'
import { debounce } from 'lodash'
import { toast } from 'react-toastify'
import Helpers from '../../services/helpers.jsx'

class CollectionList extends React.Component {
	constructor(props) {
		super(props)

		const columns = [
			{
				label: 'Collection name',
				key: 'name',
				canSort: true,
				onSortClick: column => this.onSort(column.key)
			},
			{
				label: 'Playlists',
				key: 'playlists',
				view: (field) => {
					if(!field)
						return '-'
					return field.length
				}
			},
			{
				label: "Usage",
				key: "linkedCampaigns",
				canSort: true, 
				onSortClick: column => this.onSort(column.key)
			},
			{
				label: 'Created',
				key: 'createdAt',
				view: function(field) {
					return moment(field).format('l')
				},
				canSort: true,
				onSortClick: column => this.onSort(column.key)
			},
			{
				label: 'Updated',
				key: 'updatedAt',
				view: function(field) {
					return moment(field).format('l')
				},
				canSort: true,
				onSortClick: column => this.onSort(column.key)
			},
		];
		if (Helpers.checkPermissions("collections:delete")) {
			columns.push({
				action: 'delete',
				onClick: (id, key) => {
					var r = window.confirm("Are you sure you want to delete this collection?");
					if (r === false) return

					this.setState({ loading: true })
					API.delete('collections', id).then(() => {
						toast.success('Collection was successfully deleted')
						this.loadEntities()
					}).catch(() => {
						// toast.success('An unexpected error has occurred')
						this.setState({ loading: false })
					})
				}
			});
		}

		const actions = [];
		if (Helpers.checkPermissions("collections:edit")) {
			actions.push({
				classList: 'blue add',
				label: 'New collection',
				onClick: () => this.props.history.push('/assets/collections/new')
			});
		}

		this.state = {
			clients: [],
			loading: true,
			filters: {},
			sort: ['updatedAt', 'DESC'],
			tabs: {
				links: [
					{ title: 'Playlists', path: '/assets/playlists' },
					{ title: 'Collections', path: '/assets/collections' }
				]
			},
			collections: {
				columns,
				entities: [],
				filters: [{
					label: 'Search for a collection',
					onChange: debounce(value => {
						if(value !== this.state.filters.name)
							this.setState({ filters: { ...this.state.filters, name: value ? '/' + value + '/i' : '' }}, () => {
								this.loadEntities()
							})
					}, 500)
				}],
				actions,
				selectedItems: [],
				multiSelect: false,
				onRowClick: (entity) => {
					if (
						Helpers.checkPermissions(
							["collections:details", "collections:edit"],
							true
						)
					) {
						this.props.history.push('/assets/collections/' + entity.id)
					}
				}
			}
		}
	}

	componentDidMount() {
		this.loadEntities()
	}

	onSort(key){
		const newSort = this.state?.sort?.[0] === key ? 
		this.state?.sort?.[1] === "ASC" ? [key, 'DESC'] : [key, 'ASC'] 
		: [key, 'ASC'];
		this.setState({
			sort: newSort
		}, () => {
			this.loadEntities()
		})
	}

	loadEntities() {
		API.getCollections(this.state.filters, this.state.sort)
			.then(entities => {
				const filters = [];
				if (entities?.filters?.availableFilters) {
					Helpers.handleFilters(this, filters, entities);
				}

				this.setState({
					...this.state,
					collections: {
						...this.state.collections,
						filters,
						entities: entities?.data,
					},
					loading: false
				})
			})
	}

	render() {
		if(this.state.loading)
			return <Loader />
		else
			return <>
				<Head title={'Collections'} tabs={this.state.tabs} />
				<Content>
					<Table settings={this.state.collections} sort={this.state.sort} />
				</Content>
			</>
	}
}

export default CollectionList;
